var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var scrollTo = require( 'scrollTo' );
var accordion = require( './lib/vendor/jquery.accordion.js' );
var slick = require( './lib/vendor/slick.js' );
var foundation = require( './lib/vendor/foundation.js' );
var BigText = require( './lib/vendor/bigtext.js' );
var Maintenance = require( './lib/maintenance.js' );
var initializeModules = require( './lib/init-modules.js' );
var Clipboard = require( 'clipboard' );
var moment = require( 'moment' );
var Pikaday = require( 'pikaday' );
var DropcapJS = require( 'dropcap.js' );
var DekodeWoo = require( './lib/woocommerce.js' );
var Header = require( '../../modules/header/header.js' );
var MegaMenu = require( '../../modules/mega-menu/mega-menu.js' );
var ToolBox = require( '../../modules/toolbox/toolbox.js' );
var ToolboxSearch = require( '../../modules/toolbox-search/toolbox-search.js' );
var ToolboxWishlists = require( '../../modules/toolbox-wishlists/toolbox-wishlists.js' );
var HomeHero = require( '../../modules/home-hero/home-hero.js' );
var TextTile = require( '../../modules/part-text-tile/part-text-tile.js' );
var FlexFourth = require( '../../modules/flex-product-one-fourth/flex-product-one-fourth.js' );
var ArticleBody = require( '../../modules/article-body/article-body.js' );
var FeatureImg = require( '../../modules/flex-article-image-carousel/flex-article-image-carousel.js' );
var MailChimp = require( '../../modules/flex-mailchimp-signup/flex-mailchimp-signup.js' );
var Footer = require( '../../modules/footer/footer.js' );
var BottomBanners = require( '../../modules/bottom-banners/bottom-banners.js' );
var ProductFilters = require( '../../modules/product-filters/product-filters.js' );
var ProductSorter = require( '../../modules/product-sorter/product-sorter.js' );
var BrandSorter = require( '../../modules/brand-sorter/brand-sorter.js' );
var SeriesSorter = require( '../../modules/series-sorter/series-sorter.js' );
var ArchiveDescription = require( '../../modules/archive-description/archive-description.js' );

//var retinajs = require( 'retina.js' );

$( function () {

	initializeModules();

	var $window = $( window ),
		$body = $( 'body' ),
		dropcap = document.querySelectorAll( ".dropcap" ),
		thisH, maxH = 0;

	var init = function () {

		window.Dropcap.layout( dropcap, 2 );
		new Clipboard( '.click-to-copy' );
		var picker = new Pikaday( {
			field: document.getElementsByClassName( 'datepicker' ),
			format: 'DD MM YYYY'
		} );

		$( '.link-to-top' ).click( function ( e ) {
			e.preventDefault();
			$.scrollTo( 'body', 400, { offset: 0 } );
		} );

	};

	/* Technique from http://blog.christoffer.me/six-things-i-learnt-about-ios-safaris-rubber-band-scrolling/ */
	document.ontouchmove = function ( event ) {

		var isTouchMoveAllowed = true, target = event.target;

		while ( target !== null ) {
			if ( target.classList && target.classList.contains( 'disable-scrolling' ) ) {
				isTouchMoveAllowed = false;
				break;
			}
			target = target.parentNode;
		}

		if ( !isTouchMoveAllowed ) {
			event.preventDefault();
		}
	};

	init();

	Maintenance.init();
	DekodeWoo.init();
	Header.init();
	MegaMenu.init();
	FlexFourth.init();
	TextTile.init();
	ToolBox.init();
	ToolboxSearch.init();
	ToolboxWishlists.init();
	HomeHero.init();
	Footer.init();
	MailChimp.init();
	BottomBanners.init();

	if ( $body.hasClass( 'post-type-archive-product' ) || $body.hasClass( 'tax-product_cat' ) || $body.hasClass( 'tax-product_brand' ) || $body.hasClass( 'tax-product_series' ) ) {
		ProductFilters.init();

		if ( $window.width() < 1000 ) {
			ProductFilters.mobile_button();
		}

		ProductSorter.init();
		BrandSorter.init();
		SeriesSorter.init();

		BrandSorter.refresh();
		SeriesSorter.refresh();
		ArchiveDescription.init();
	}

	$( document ).foundation();

	$window.on( 'load', function () {

		FeatureImg.load();
		ArticleBody.init();

		$( document.getElementsByClassName( 'woocommerce-accordion' ) ).accordion();

		if ( $window.width() < 767 ) {
			$( document.getElementsByClassName( 'footer-accordion' ) ).accordion();
		}

	} );

	$window.resize( function () {

		MegaMenu.init();
		ToolBox.init();
		ToolboxSearch.init();
		FeatureImg.load();
		ArticleBody.init();
		FlexFourth.init();

		if ( $window.width() < 767 ) {
			if ( $( '.footer-accordion' ).length > 0 ) {
				$( document.getElementsByClassName( 'footer-accordion' ) ).accordion();
			}
		}

		if ( $body.hasClass( 'post-type-archive-product' ) || $body.hasClass( 'tax-product_cat' ) ) {

			if ( $window.width() < 1000 ) {
				ProductFilters.mobile_button();
			}
		}
	} );

} );
